import config from '../../config';

import { HttpLink, InMemoryCache, ApolloClient, ApolloLink } from '@apollo/client';
import jsCookie from 'js-cookie';
import { onError } from '@apollo/client/link/error';
import { logger } from '../../utility/ErrorLogger';
import { MultiAPILink } from '@habx/apollo-multi-endpoint-link';
const { graphql } = config;

// const httpLink = new HttpLink({ uri: graphqlPath });
const httpLink = new HttpLink({
  uri: `/${graphql.path}`,
  opts: {
    credentials: 'include',
  },
  credentials: 'include',
});

const logoutLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ error_code, message }) => {
      if (message) logger.log('[Error message]: ', message);
      if (
        +error_code === 100 &&
        !window.location.pathname.includes('/login/') &&
        !window.location.pathname.includes('/builds/')
      ) {
        jsCookie.remove('isAuthenticated');
        const userType = localStorage.getItem('userType');
        userType === 'customer'
          ? (window.location.href = '/login/customer/')
          : (window.location.href = '/login/employee/');
      }
    });
  }
  if (networkError) logger.log(`[Network error]: ${networkError}`);
});

const cache = new InMemoryCache({
  typePolicies: {
    UserType: {
      fields: {
        customerprofile: {
          merge(_ignored, incoming) {
            return incoming;
          },
        },
        employeeprofile: {
          merge(_ignored, incoming) {
            return incoming;
          },
        },
      },
    },
  },
});

const ROOT_PATH = '/graphql';
const HOST_NAME = process.env.HOST_NAME || 'http://api.soliderp.io:9000';

const Client = new ApolloClient({
  cache,
  link: ApolloLink.from([
    new MultiAPILink({
      endpoints: {
        root: `${HOST_NAME}${ROOT_PATH}`,
        admin: `${HOST_NAME}${graphql.pathAdmin}`,
        reporting: `${HOST_NAME}${graphql.pathReports}`,
      },
      httpSuffix: '/',
      createHttpLink: () => logoutLink.concat(httpLink),
    }),
  ]),
});

export default Client;
